import * as React from 'react';
import * as styles from '../styles.module.less';
import { Wrapper } from './Header';

import FooterLinkList from './footer-link-list';
import SecurityPart from './security-part';
import SwitchLanguage from './switch-language';
import { Caption } from '@/components';

interface IProps {
  isMediaTool: boolean;
  isNewLayout?: boolean;
}

const Component: React.FC<IProps> = ({ isMediaTool, isNewLayout = false }) => {
  const LinkWrapper = Wrapper(isMediaTool);

  return (
    <div className={`${styles.footer_container}`}>
      {/* <div className="container-new footer-header w-container" /> */}
      <FooterLinkList isNewLayout={isNewLayout} isMediaTool={isMediaTool} />
      <div className={`${styles.tail} ${isNewLayout && styles.new_home_page_footer}`}>
        {/* 安全logo */}
        <div className={styles.security_switch_btn_container}>
          <SecurityPart />
          <div className={styles.desc_btn_container}>
            <Caption isWordKeepAll className={styles.security_desc}>
              「GDPR」「SSL」「SOC 2」「ISO 27001」「HIPAA」「CCPA」「APPI」の
              <wbr />
              認証
              <wbr />を<wbr />
              取得
              <wbr />
              して
              <wbr />
              います。
            </Caption>
            <SwitchLanguage
              className={styles.switch_language_dropdown_container}
              data={{
                currentLanguage: '日本語',
                languageList: [
                  {
                    label: 'English',
                    link: '/en',
                  },
                ],
              }}
            />
          </div>
        </div>
        {/* copyright */}
        <div className={styles.copyright_container}>
          <p className="caption-new left-aligned footer">
            🍀 &nbsp;NottaはDX推進・ペーパーレス化に応援します。取材、プレスリリース、レビュー等に関するお問い合わせ:{' '}
            <a href="mailto:contact@notta.ai" className="link-new footer">
              contact@notta.ai{' '}
            </a>
            <br />
            Copyright © 2024 Notta. All Rights Reserved.{' '}
            <LinkWrapper to="/terms" target="_blank" className="link-new footer">
              利用規約
            </LinkWrapper>
            ｜
            <LinkWrapper to="/privacy" target="_blank" className="link-new footer">
              プライバシー
            </LinkWrapper>
            ｜
            <LinkWrapper to="/sitemap" target="_blank" className="link-new footer">
              サイトマップ{' '}
            </LinkWrapper>
            ｜
            <LinkWrapper to="/share-jp" target="_blank" className="link-new footer">
              友達紹介キャンペーン利用規約{' '}
            </LinkWrapper>
            ｜
            <LinkWrapper to="/security" target="_blank" className="link-new footer">
              セキュリティシステム{' '}
            </LinkWrapper>
            <br />
          </p>
          <SwitchLanguage
            className={styles.switch_language_dropdown_container}
            data={{
              currentLanguage: '日本語',
              languageList: [
                {
                  label: 'English',
                  link: '/en',
                },
              ],
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Component;
